import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { NetworkOutageItem } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  params?: {
    dateFrom: string;
    dateTo?: string;
    sensorType?: 'verizon' | 'lorawan';
  };
  options?: Omit<
    UseQueryOptions<NetworkOutageItem[], Error>,
    'queryKey' | 'queryFn'
  >;
}

export const useNetworkOutagesRequest = ({
  params = { dateFrom: new Date().toISOString() },
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<NetworkOutageItem[], Error>(
    [Entities.Diagnostics, 'network-outages', JSON.stringify(params)],
    async () => {
      const { dateFrom, sensorType, dateTo } = params
      const { data } = await api.v1AdminHardwareNetworkOutagesGet(dateFrom, sensorType, dateTo)
      return data as NetworkOutageItem[]
    },
    options,
  )
}
